<template src="./NotAuthorized.html"></template>
<style lang="scss" scoped src="./NotAuthorized.scss"></style>

<script>
import {
  SfBreadcrumbs,
  SfButton,
  SfHeading
} from '@storefront-ui/vue';

export default {
  name: "NotAuthorized",
  components: {
    SfHeading,
    SfButton,
    SfBreadcrumbs
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: '401',
        }
      ]
    };
  },
  mounted() {
    window.onpopstate = function (event) {
      history.go(-2);
    }
  },
}
</script>
